import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        await refresh();
        // First-login onboarding: route NEW users (profile_completed === false) into the
        // profile-capture flow. Returning users go straight to the Decision Desk.
        // Users who abandon the flow keep returning here until they save their profile,
        // because /auth/session always reflects the latest persisted flag.
        const dest = data?.user?.profile_completed === false ? "/profile" : "/dashboard";
        window.history.replaceState({}, "", dest);
        nav(dest, { replace: true, state: { user: data.user } });
      } catch {
        setErr("Could not complete sign-in. Please try again.");
        setTimeout(() => nav("/"), 2500);
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="text-micro font-semibold tracking-[0.05em] uppercase text-[var(--s400)] mb-3">Authenticating</div>
        <div className="text-h2 font-semibold text-[var(--s900)]">
          {err || "Completing sign-in…"}
        </div>
      </div>
    </div>
  );
}
